import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Box, Typography, Divider } from '@mui/material';

const ModalScaffold = ({
  open,
  onClose,
  maxWidth = 'sm',
  title,
  subtitle,
  icon: Icon,
  children,
  actions,
  contentSx,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', boxShadow: (t) => t.shadows[10] } }}>
      <DialogTitle sx={{ p: 2, background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)', color: 'white' }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {Icon && (
            <Box sx={{ bgcolor: 'rgba(255,255,255,0.2)', borderRadius: '10px', p: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon />
            </Box>
          )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }} noWrap>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={[{ p: 3, pt: 3.5, bgcolor: '#fafafa' }, contentSx]}>{children}</DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2, gap: 1.5, position: 'sticky', bottom: 0, bgcolor: 'background.paper' }}>
        {actions}
      </DialogActions>
    </Dialog>
  );
};

export default ModalScaffold;
